"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));
var _ContainerHeader = _interopRequireDefault(require("./ContainerHeader"));
var _Sidebar = _interopRequireDefault(require("./Sidebar"));
var _NotConnected = _interopRequireDefault(require("./NotConnected"));
var _MessageList = _interopRequireDefault(require("./MessageList"));
var _ServerView = _interopRequireDefault(require("./ServerView"));
var _NavBar = _interopRequireDefault(require("./NavBar"));
var _ImVerified = _interopRequireDefault(require("./ImVerified"));
var _MyProfile = _interopRequireDefault(require("./MyProfile"));
var _default = exports.default = {
  components: {
    ContainerHeader: _ContainerHeader.default,
    Sidebar: _Sidebar.default,
    NotConnected: _NotConnected.default,
    MessageList: _MessageList.default,
    ServerView: _ServerView.default,
    NavBar: _NavBar.default,
    ImVerified: _ImVerified.default,
    MyProfile: _MyProfile.default
  },
  props: ['network', 'buffer', 'sidebarState'],
  data: function data() {
    return {
      activeComponent: ''
    };
  },
  computed: {
    bufferType: function bufferType() {
      let type = '';
      if (!this.buffer) {
        type = 'none';
      } else if (this.buffer.isServer()) {
        type = 'server';
      } else if (this.buffer.isChannel()) {
        type = 'channel';
      } else if (this.buffer.isQuery()) {
        type = 'query';
      }
      return type;
    },
    unreadMessages() {
      let count = 0;
      let highlight = false;
      this.$state.networks.forEach(network => {
        network.buffers.forEach(buffer => {
          count += (0, _flags.default)(buffer).unread || 0;
          if ((0, _flags.default)(buffer).highlight) {
            highlight = true;
          }
        });
      });
      return {
        count,
        highlight
      };
    }
  },
  created: function created() {
    this.listen(this.$state, 'sidebar.toggle', () => {
      this.$state.$emit('sidebar.' + (this.sidebarState.isDrawn ? 'hide' : 'show'));
    });
    this.listen(this.$state, 'sidebar.show', () => {
      this.sidebarState.showNicklist();
    });
    this.listen(this.$state, 'sidebar.hide', () => {
      this.sidebarState.close();
    });
    this.listen(this.$state, 'active.component', componentName => {
      this.activeComponent = componentName;
    });
    this.listen(this.$state, 'userbox.show', (user, opts) => {
      this.sidebarState.showUser(user);
    });
    this.listen(this.$state, 'userbox.hide', () => {
      this.sidebarState.close();
    });
    this.listen(this.$state, 'document.keydown', ev => {
      // Return if not Page Up or Page Down keys
      if (ev.key !== 'PageUp' && ev.key !== 'PageDown') {
        return;
      }

      // if no messagelist, select the first tabbed content to allow channel list scrolling
      let messageList = this.$el.querySelector('.kiwi-messagelist') || this.$el.querySelector('.u-tabbed-content');
      if (!messageList) {
        return;
      }

      // Fix for chrome issue breaking layout when page up/down is pressed while inside
      // contenteditible or inputbox
      // https://bugs.chromium.org/p/chromium/issues/detail?id=890248
      ev.preventDefault();
      let scrollDistance = messageList.clientHeight - 0.1 * messageList.clientHeight;
      let scrollTop = messageList.scrollTop;
      let scrollMax = messageList.scrollHeight;
      if (ev.key === 'PageUp') {
        // up
        scrollTop -= scrollDistance;
        if (scrollTop < 0) {
          scrollTop = 0;
        }
      } else {
        // down
        scrollTop += scrollDistance;
        if (scrollTop > scrollMax) {
          scrollTop = scrollMax;
        }
      }
      messageList.scrollTop = scrollTop;
    });
  },
  methods: {
    toggleStateBrowser: function toggleStateBrowser() {
      this.$state.$emit('statebrowser.toggle');
    },
    toggleSidebar: function toggleSidebar() {
      if (this.buffer.isChannel()) {
        this.$state.$emit('sidebar.toggle');
      }
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["Container"]
window._kiwi_exports.components.Container = exports.default ? exports.default : exports;
